import { useEffect, useState } from 'react'
// import { loadConnectAndInitialize } from '@stripe/connect-js';
// import { ConnectComponentsProvider, ConnectPayments } from '@stripe/react-connect-js';
import { ReactComponent as AddCircleIcon } from '../../../icons/AddCircleIcon.svg'
// import { ReactComponent as EditIcon } from '../../../icons/EditIcon.svg'
import { useCompleteSignIn } from '../../../hooks/authhooks'

// import { ReactComponent as WalletIcon } from "../../../icons/WalletIcon.svg";
import CancelIcon from "@mui/icons-material/Cancel";

import { useGetPaymentMethods, useGetPaymentHistory } from '../../../hooks/paymenthooks'
// import StripePaymentCheckOut from "../../../molecules/PaymentCheckOut"
import PaginatedList from '../../../components/Mobile/PaginatedList';
import PayMethodComponent from '../../../components/Mobile/PayMethodComponent';
import { AccountSchema } from '../../../data/types';
import PaymentHistory from '../../../molecules/Mobile/PaymentHistory';
import { AddPaymentMethodModal } from '../../../molecules/Mobile/AppModal';
import { ArrowBack } from '@mui/icons-material';
import PaymentMethodsSkeleton from '../../../components/PaymentMethodsSkeleton';

type menuOptionTypes = "payment_methods" | "payment_history"

const Wallet = () => {
  // const [isUpdatingPayMethod, setIsUpdatingPayMethod] = useState<boolean>(false)
  const menuOptions: {id: menuOptionTypes, name: string}[] = [
    {id: "payment_methods", name: "Payment Methods"}, 
    {id: "payment_history", name: `Payment History`} 
  ]
  const [currentOption, setCurrentOption] = useState<menuOptionTypes>(menuOptions[0].id)
  const { user, isLoadingUser, isFetchingUser } = useCompleteSignIn();
  const isUserLoading = isLoadingUser || (isFetchingUser && !user)

  useEffect(() => {
    document.title = `HomeCook | Resource Pantry`
  }, [])

  return (
    <>
    <div className={`w-full left-0 flex font-open-sans overflow-y-scroll relative  top-0 justify-center bg-gradient-to-b from-[#F5F5F5]  backdrop-blur-2xl bg-[#F5F5F5]`}>
      
      <div className={`flex flex-col w-full relative items-start  bg-white`}>
          <div className='w-full px-5 '>
          <p className='font-raleway text-[18px] text-gray-400 font-bold mt-5'><ArrowBack/> <span className='pt-1'>Go Back</span></p>

            <p className='font-raleway text-[25px] text-black font-bold mt-5'>Payment Details</p>


            <div className="flex flex-row flex-nowrap bg-white  items-center overflow-x-auto">
              {
                menuOptions.map((option, i) => {
                  return (
                    <div 
                      key={i} 
                      onClick={()=>setCurrentOption(option.id)} 
                      className={`${(currentOption === option.id) ? 'text-white bg-primaryDark-0' : 'text-[#4D4D4D] '} mr-6 text-[18px] font-raleway border-[1px] border-[#E9E9E9] py-3 px-4 rounded-xl font-semibold cursor-pointer whitespace-nowrap flex-shrink-0`}
                    >
                        {option.name}
                    </div>
                  )
                })
              }
            </div>
            {
              currentOption === "payment_methods" && (
                <WalletPaymentMethods user={user as AccountSchema} isUserLoading={isUserLoading} />
              )
            }
            {
              currentOption === "payment_history" && (
                <WalletPaymentHistory user={user as AccountSchema} isUserLoading={isUserLoading} />
              )
            }

          </div>
      </div>
    </div>
    </>
  )
}


type WalletPaymentMethodsProps = {
  user: AccountSchema
  isUserLoading?: boolean
}

const WalletPaymentMethods: React.FC<WalletPaymentMethodsProps> = ({user, isUserLoading = false}) => {

  
  const loggedinUsername = (user && user?.username) ? user.username : ''
  const loggedinUid = (user && user?.uid) ? user.uid : ''

  var {
    paymentMethods,
    reloadPaymentMethods,
    isLoadingPaymentMethods,
    isFetchingPaymentMethods,
  } = useGetPaymentMethods(loggedinUid)
 
  // const [isAddingPayMethod, setIsAddingPayMethod] = useState<boolean>((paymentMethods && paymentMethods.length < 1) ? true : false)
  const [isAddingPayMethod, setIsAddingPayMethod] = useState<boolean>(false)

  const isPaymentMethodsLoading =
    isUserLoading ||
    isLoadingPaymentMethods ||
    (isFetchingPaymentMethods && !paymentMethods)

  paymentMethods = (paymentMethods && Array.isArray(paymentMethods)) ? paymentMethods : []


  useEffect(() => {
    document.title = `HomeCook | Resource Pantry`
  }, [paymentMethods])

 
  return (
    <>
      <div className='  p-5 w-full bg-white overflow-hidden border-[1px] border-[#E9E9E9] rounded-xl mt-5 mb-10'>
        
        {
          (isAddingPayMethod && paymentMethods && paymentMethods.length > 0) && (
            <div 
              onClick={()=>setIsAddingPayMethod(false)}
              className='flex flex-row w-full text-gray-300 font-raleway font-bold text-[20px] cursor-pointer'
            >
              <CancelIcon className='ml-auto' />
            </div>
          )
        } 
          
        
        {
          (isAddingPayMethod) ? (
            <AddPaymentMethodModal loggedinUid={loggedinUid} isOpen={isAddingPayMethod} setIsOpen={()=>setIsAddingPayMethod(false)} />
            // <div className=''>
            //   <p className='text-[18px] font-raleway text-black font-bold'>Add Your Payment Method</p>
            //   <p className='text-[14px] font-open-sans text-[#808080] mt-2 mb-4'>
            //     Choose your payment method from the available options below.
            //   </p>
              
            //   <div className='flex flex-row rounded-md mb-7 sm:h-[40px] w-[90px] bg-primaryDark-0 text-[14px] text-white font-bold font-raleway'>
            //     <WalletIcon className='my-auto ml-auto mr-1' />
            //     <p className='my-auto mr-auto'>Card</p>
            //   </div>

            //   <StripePaymentCheckOut uid={loggedinUid} mode="setup" currency="usd" setup_future_usage='off_session' isAddPayMethod={isAddingPayMethod} setIsAddingPayMethod={setIsAddingPayMethod} />
            // </div>
          ) : isPaymentMethodsLoading ? (
            <PaymentMethodsSkeleton variant="mobile" />
          ) : (
            <div className=''>
              <p className='text-[20px] font-raleway text-black font-semibold'>Your Payment Methods</p>
              <div className='flex flex-col'>
                <p className='text-[16px] font-open-sans text-[#808080] mb-6 mt-2'>
                  Manage your saved payment methods below.
                </p>

                <button 
                  onClick={()=>setIsAddingPayMethod(true)} 
                  className='flex flex-row bg-primaryDark-0 hover:bg-primaryDark-300 text-white font-raleway font-bold text-[14px] rounded-md border-0 py-[12px] px-[18px] w-full justify-center'
                >
                  <AddCircleIcon className='mr-2 fill-white text-primaryDark-0' /> 
                  Add a Payment Method
                </button>
              </div>

              <div className='mt-5 '>
                <PaginatedList
                  items={paymentMethods}
                  itemsPerPage={5}
                  renderItem={(paymentMethod: any, index: number) => (
                    <PayMethodComponent
                      key={index}
                      paymentMethod={paymentMethod}
                      username={loggedinUsername}
                      reloadPaymentMethods={reloadPaymentMethods}
                    />
                  )}
                  emptyMessage="No payment methods available"
                />
              </div>
            </div>
          )
        }
        
      </div>
    </>
  )
}


type WalletPaymentHistoryProps = {
  user: AccountSchema
  isUserLoading?: boolean
}

const WalletPaymentHistory: React.FC<WalletPaymentHistoryProps> = ({user, isUserLoading = false}) => {

  const loggedinUid = (user && user?.uid) ? user.uid : ''

  const {
    paymentHistory,
    isLoadingPaymentHistory,
    isFetchingPaymentHistory,
  } = useGetPaymentHistory(loggedinUid)

  const isPaymentHistoryLoading =
    isUserLoading ||
    isLoadingPaymentHistory ||
    (isFetchingPaymentHistory && !paymentHistory)

  useEffect(() => {
    document.title = `HomeCook | Resource Pantry`
  }, [])

    return (
    <div className='border-[1px] border-[#E9E9E9] rounded-xl sm:min-h-[520px]  p-5 w-full bg-white'>
        <PaymentHistory
          paymentHistoryList={paymentHistory ? paymentHistory : []}
          isLoading={isPaymentHistoryLoading}
        />
    </div>
  )
}




export default Wallet